import { createFileRoute } from "@tanstack/react-router";
import {
  CollectionPage,
  collectionLoader,
  collectionHeadEn,
  CollectionErrorComponent,
  CollectionNotFoundComponent,
} from "@/pages/CollectionPage";

export const Route = createFileRoute("/en/collections/$handle")({
  loader: collectionLoader,
  head: collectionHeadEn,
  component: CollectionPage,
  errorComponent: CollectionErrorComponent,
  notFoundComponent: CollectionNotFoundComponent,
});
